module.exports = __webpack_public_path__ + "static/img/icon@2x.c9f6d8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ktb_min/icon@2x.png
// module id = eu3G
// module chunks = 70